import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import SEO from '../components/SEO';
import './Auth.css';

const Login = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailNotVerified, setEmailNotVerified] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
    setEmailNotVerified(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.email, formData.password);
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.message || t('auth.loginError'));
      setEmailNotVerified(result.code === 'EMAIL_NOT_VERIFIED');
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <SEO title={t('auth.login')} path="/login" noIndex />
      <div className="auth-card">
        <h2>{t('auth.login')}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.email')}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>{t('auth.password')}</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <p className="auth-link" style={{ marginTop: '0', marginBottom: '10px', textAlign: 'right' }}>
            <Link to="/forgot-password">{t('auth.forgotPassword')}</Link>
          </p>
          {error && (
            <>
              <div className="error-message">{error}</div>
              {emailNotVerified && (
                <p className="auth-link" style={{ marginTop: '8px' }}>
                  <Link to="/check-email" state={{ email: formData.email, message: error }}>{t('auth.resendVerification') || 'Resend verification email'}</Link>
                </p>
              )}
            </>
          )}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Loading...' : t('auth.login')}
          </button>
        </form>
        <p className="auth-link">
          {t('auth.noAccount')} <Link to="/register">{t('auth.register')}</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
